import { Effect } from "../../Materials/effect";
var name = 'instancesVertex';
var shader = "#ifdef INSTANCES\nmat4 finalWorld=mat4(world0,world1,world2,world3);\n#ifdef THIN_INSTANCES\nfinalWorld=world*finalWorld;\n#endif\n#else\nmat4 finalWorld=world;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var instancesVertex = { name: name, shader: shader };
//# sourceMappingURL=instancesVertex.js.map